import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Translate, withLocalize } from 'react-localize-redux';
import Icon, { IconSizes, IconTypes, IconVariants } from '../../../components/foundations/Icon';
import { formatChangePct } from '../../consts';
import css from './TopMovers.css';

const TRANSLATION_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS.TOP_MOVERS';

const MoverPath = ({ dimValues }) => (
    <span className={css.moverPath}>
        {dimValues.map((part, i) => (
            <React.Fragment key={dimValues.slice(0, i + 1).join(':')}>
                {i > 0 && <Icon name="arrow-right" size={IconSizes.X_SMALL} interactive={false} />}
                <span className={classNames({ [css.moverPathActive]: i === dimValues.length - 1 })}>{part}</span>
            </React.Fragment>
        ))}
    </span>
);

MoverPath.propTypes = {
    dimValues: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const TopMovers = ({ movers, increasesAreGood = true, metricLabel = '', onInvestigate, onClose, translate }) => {
    if (!movers.length) return null;

    return (
        <div className={css.topMovers}>
            <div className={css.header}>
                <div className={css.title}>
                    <Icon name="sparkles" size={IconSizes.SMALL} interactive={false} />
                    <Translate id={`${TRANSLATION_PREFIX}.TITLE`} />
                </div>
                <button
                    type="button"
                    className={css.closeButton}
                    aria-label={translate(`${TRANSLATION_PREFIX}.CLOSE`)}
                    onClick={onClose}
                >
                    <Icon
                        type={IconTypes.MINGCUTE}
                        name="close-line"
                        variant={IconVariants.DARK}
                        size={IconSizes.SMALL}
                        interactive={false}
                    />
                </button>
            </div>
            <div className={css.subtitle}>
                <Translate id={`${TRANSLATION_PREFIX}.SUBTITLE`} data={{ metric: metricLabel }} />
            </div>
            <div className={css.moverList}>
                {movers.map(point => {
                    const pct = point.custom?.rawColorChangePct;
                    const isGood = pct > 0 === increasesAreGood;
                    return (
                        <div key={point.id} className={css.moverRow} onClick={() => onInvestigate(point)}>
                            <MoverPath dimValues={point.custom?.dimValues ?? []} />
                            <span className={classNames(css.moverChange, isGood ? css.goodChange : css.badChange)}>
                                {formatChangePct(pct)}
                            </span>
                            <span className={css.moverCta}>
                                <Icon name="sparkles" size={IconSizes.X_SMALL} interactive={false} />
                                <Translate id={`${TRANSLATION_PREFIX}.INVESTIGATE`} />
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

TopMovers.propTypes = {
    movers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            custom: PropTypes.shape({
                dimValues: PropTypes.arrayOf(PropTypes.string),
                rawColorChangePct: PropTypes.number,
            }),
        })
    ).isRequired,
    increasesAreGood: PropTypes.bool,
    metricLabel: PropTypes.string,
    onInvestigate: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(TopMovers);
